var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56589 10.0577C6.56589 9.71601 6.84922 9.43268 7.19089 9.43268H11.7576V2.38268C11.7492 1.98268 11.4326 1.66602 11.0326 1.66602C6.12422 1.66602 2.69922 5.09102 2.69922 9.99935C2.69922 14.9077 6.12422 18.3327 11.0326 18.3327C11.4242 18.3327 11.7492 18.016 11.7492 17.616V10.6743H7.19089C6.84089 10.6827 6.56589 10.3993 6.56589 10.0577Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1167 9.6168L14.75 7.2418C14.5083 7.00013 14.1083 7.00013 13.8667 7.2418C13.625 7.48346 13.625 7.88346 13.8667 8.12513L15.1667 9.42513H11.75V10.6751H15.1583L13.8583 11.9751C13.6167 12.2168 13.6167 12.6168 13.8583 12.8585C13.9833 12.9835 14.1417 13.0418 14.3 13.0418C14.4583 13.0418 14.6167 12.9835 14.7417 12.8585L17.1083 10.4835C17.3583 10.2501 17.3583 9.85846 17.1167 9.6168Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.fcfc3f23c3688f0a686240887ebf3fd5.svg";
export { ForwardRef as ReactComponent };